<template>
                    
<section class="login" :style="{
    'background-image': 'url(' + backgroundImage + ')'
  }">
  <header-logged-out :type="type"></header-logged-out>
  <v-container fill-height>
    <v-row class="fill-height" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="4">
        <v-card>
          <form @submit.prevent="submit">
            <v-toolbar dark color="primary" flat>
              <v-toolbar-title>{{ label }} Login</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-text-field v-model="cred" v-validate="
                  credLabel === 'E-mail'
                    ? 'email|required|max:150'
                    : 'required|max:150'
                " :error-messages="errors.collect('cred')" :label="credLabel" :hint="
                  `Enter your ${
                    credLabel === 'E-mail'
                      ? 'username or email'
                      : 'student code'
                  } you used when you registered`
                " data-vv-name="cred" data-vv-as="username or email" required></v-text-field>
              <v-text-field v-model="password" name="password" label="Enter your password" hint="Make sure your password is 6 to 20 characters long" min="6" :append-icon="visible ? 'visibility' : 'visibility_off'" @click:append="visible = !visible" :error-messages="errors.collect('password')" v-validate="'required|min:6|max:20'" data-vv-name="password" required :type="visible ? 'text' : 'password'"></v-text-field>
              <template>
                <router-link :to="`/${type}/forgotpassword`" style="color: #1565c0">
                  Forgot password?
                </router-link>
              </template>
            </v-card-text>
            <v-card-actions class="px-3 pb-3 pt-0">
              <template>
                <div>
                  First time here?
                  <router-link :to="`/${type}/signup`" style="color: #1565c0">
                    Create an account.
                  </router-link>
                </div>
              </template>
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" :loading="loading" :disabled="loading">
                Login
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
        <custom-snackbar></custom-snackbar>
      </v-col>
    </v-row>
  </v-container>
</section>

                  </template> 
                  <script >
import { mapMutations, mapState } from 'vuex'
import HeaderLoggedOut from '@/modules/auth/views/HeaderLoggedOut'
import CustomSnackbar from '@/components/snackbar/snackbar'
// import Auth from '@/modules/auth/models/Auth'

export default {
  name: 'Login',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    CustomSnackbar,
    HeaderLoggedOut
  },
  data() {
    return {
      cred: '',
      visible: false,
      password: '',
      loading: false,
      type: '',
      label: '',
      credLabel: ''
    }
  },
  computed: {
    ...mapState(['bucketUrl']),
    backgroundImage() {
      return ''
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async submit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        return // there are errors
      }
      try {
        let form = {
          username: this.cred,
          password: this.password
        }
        this.loading = true

        await this.dispatchMethod(form)
        // await Auth.dispatch('resetActivity', `${this.type}s`)
        if (this.$route.query.redirect) {
          window.location.href = this.$route.query.redirect
          return
        }

        this.$router.push(`/${this.type}/dashboard/overview`)

        this.loading = false
      } catch (error) {
        let status = error.response.status
        this.loading = false
        if (status === 422) {
          this.showErrorSnackbar(
            `One of the fields could not be validated.\n ${error.message}: ${error.response.data.message}`
          )
        } else if (status === 401) {
          this.showErrorSnackbar('Invalid username/password')
        } else {
          let errorMessage = `There was a server error. Contact support.\n ${error.message}: ${error.response.data.message}`
          this.showErrorSnackbar(errorMessage)
        }
      }
    },
    async dispatchMethod(form) {
      throw 'This function needs to be overriden ' + form
    }
  }
}
</script><style  lang="scss"  scoped="true" >







































































































































































.login {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>